<template>
  <div>
    <div class="row slopePage__pane slopePage__pane-similar">
        <div class="col-12 similar__wrapper">
         <div class="similar__box" v-if="isContr">
            <div class="similar__box-title slopePage__subtitle">
              Basic roof slope</div>
              <div class="similar__box-inputs">
                <input type="range"
                       v-model.number="slope.slopeParams[0].roofSlope"
                       min="1.5"
                       max="10"
                       step="0.1"
                       class="similar__box-inputs-range"
                       :style="`--min: 1.5;--max: 10;--val: ${slope.slopeParams[0].roofSlope};`"
                       ref="inputRange"
                       @change="changeRoofSlope">
                <div class="similar__box-inputs-input info">
                  {{ slope.slopeParams[0].roofSlope }}%</div>
              </div>
          </div>
          <div class="similar__box">
            <div class="similar__box-title slopePage__subtitle">
              <!--@TODO perevod-->
              The number of similar <span v-if="isContr">counter slope</span>
              <span v-else>main slope</span> areas</div>
              <div class="similar__box-inputs">
                <button @click="slope.slopeCount -= 1; changeSlopeCount();"
                       :disabled="slope.slopeCount <= 1"
                       class="similar__box-inputs-button">
                       <img src="@/assets/img/minus.svg" alt="-"></button>
                <input type="number"
                       placeholder="count"
                       min="1"
                       v-model.number="slope.slopeCount"
                       @change="changeSlopeCount"
                       class="similar__box-inputs-input">
                <button @click="slope.slopeCount += 1; changeSlopeCount();"
                        class="similar__box-inputs-button">
                        <img src="@/assets/img/plus.svg" alt="+"></button>
              </div>
            </div>
          <div class="similar__box">
            <div class="similar__box-title slopePage__subtitle">
              The number of tapered insulation layers</div>
              <div class="similar__box-inputs">
                <button @click="slope.slopeLayersCount -= 1; changeSlopeLayersCount();"
                        :disabled="slope.slopeLayersCount <= 1"
                        class="similar__box-inputs-button">
                        <img src="@/assets/img/minus.svg" alt="-"></button>
                <input type="number"
                       placeholder="count"
                       min="1"
                       v-model.number="slope.slopeLayersCount"
                       @change="changeSlopeLayersCount"
                       class="similar__box-inputs-input">
                <button @click="slope.slopeLayersCount += 1; changeSlopeLayersCount();"
                        class="similar__box-inputs-button">
                        <img src="@/assets/img/plus.svg" alt="+"></button>
              </div>
          </div>
       </div>
      </div>
    <div class="row slopePage__pane"
         :class="{ 'slopePage__pane--contr': isContr }">
       <div class="col-12">
         <div class="fixtureCalculation__toggle">
          <div class="slopePage__subtitle">Fastener сalculation</div>
          <div class="wrapper">
            <span class="checkbox-toggler">
              <span class="checkbox-track"></span>
              <input type="checkbox"
                     v-model="slope.fixtureCalculation.need"
                     @change="changeFixtureCalculation">
              <span class="toggler"></span>
            </span>
          </div>
        </div>
       </div>
        <div class="col-lg-6 col-md-6" v-if="slope.fixtureCalculation.need && isContr">
         <div class="materials__select">
           <div class="roofType__title">The base of the counter slope is</div>
           <label class="styled-radio">оrganized by construction
             <input type="radio"
                    value="default"
                    v-model="slopeFromState.fixtureCalculation.base"
                    @change="changeFixtureCalculationBase">
             <span class="checkmark"></span>
           </label>
           <label class="styled-radio">оrganized by tapered insulation
             <input type="radio"
                    value="custom"
                    v-model="slopeFromState.fixtureCalculation.base"
                    @change="changeFixtureCalculationBase">
             <span class="checkmark"></span>
           </label>
           <multiselect v-model="slopeFromState.fixtureCalculation.material"
                placeholder="Поиск..."
                label="name"
                track-by="id"
                :options="sortedMaterials"
                :option-height="68"
                :show-labels="false"
                :allow-empty="false"
                :searchable="false"
                open-direction="bottom"
                @input="changeFixtureCalculationMaterial"
                v-if="slopeFromState.fixtureCalculation.base === 'custom'">
             <div slot="singleLabel"
                  slot-scope="props"
                  class="option__box">
               <div class="option__img">
                 <img :src="props.option.src" :alt="props.option.name">
               </div>
               <div class="option__info">
                 <div class="option__info-title">{{ props.option.name }}</div>
                 <div class="option__info-angle">
                   <img src="@/assets/img/angle.svg" alt="">{{ props.option.angle }}%
                 </div>
               </div>
             </div>
             <div slot="option"
                  slot-scope="props"
                  class="option__box">
               <div class="option__img">
                 <img :src="props.option.src" :alt="props.option.name">
               </div>
               <div class="option__info">
                 <div class="option__info-title">{{ props.option.name }}</div>
                 <div class="option__info-angle">
                   <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                     <path d="M1 10L0.589315 9.7148L1 10.5V10ZM6.83931 0.714802L0.589315
                           9.7148L1.41068 10.2852L7.66069 1.2852L6.83931 0.714802ZM11
                           9.5H1V10.5H11V9.5ZM7.75 10C7.75 7.82484 6.75448 5.77197 5.0554
                           4.46125L4.4446 5.25303C5.8931 6.37045 6.75 8.12828 6.75 10H7.75Z"
                           fill="#333333"></path>
                   </svg>
                   {{ props.option.angle }}%
                 </div>
               </div>
             </div>
           </multiselect>
         </div>
       </div>
      <div :class="{ 'col-lg-6, col-md-6': isContr, 'col-12': !isContr }"
       v-if="slope.fixtureCalculation.need">
        <div class="fixtureCalculation" :class="{ 'fixtureCalculation--contr': isContr }">
          <div class="roofType">
            <div class="roofType__title">Type of roof base</div>
            <div class="roofType__box">
              <div v-for="item in roofBaseTypes"
                   :key="item.id"
                   class="roofType__box-btn">
                <label :for="item.value"
                       :class="{'active': slope.fixtureCalculation.type === item.value}"
                       class="roofType__box-btn__label">{{ item.label }}
                </label>
                <input type="radio"
                       :id="item.value"
                       :value="item.value"
                       v-model="slope.fixtureCalculation.type"
                       @change="changeRoofBaseType">
              </div>
            </div>
          </div>
          <div class="roofType">
            <div class="roofType__title">Primary insulation thickness, mm</div>
            <div class="similar__box-inputs">
              <button @click="slope.fixtureCalculation.thickness -= 10;
                              changeFixtureCalculationThickness();"
                      :disabled="slope.fixtureCalculation.thickness <= 10"
                      class="similar__box-inputs-button">
                <img src="@/assets/img/minus.svg" alt="-"></button>
              <input type="number"
                     placeholder="count"
                     min="0"
                     step="10"
                     v-model.number="slope.fixtureCalculation.thickness"
                     @change="changeFixtureCalculationThickness"
                     class="similar__box-inputs-input">
              <button @click="slope.fixtureCalculation.thickness += 10;
                              changeFixtureCalculationThickness();"
                      class="similar__box-inputs-button">
                <img src="@/assets/img/plus.svg" alt="+"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fading">
      <div class="ratio__modal-overlay" v-if="isModalShow" @click.self="cancel()">
        <div class="ratio__modal">
          <div class="text">
            With this value of the main roof slope angle, the recommended rhombus
            diagonals ratio is: <br><span>1 to {{ recommendedRatio }}</span>
          </div>
          <div class="subtext">Change ratio?</div>
          <div class="info">* if confirm, changes will be applied automatically</div>
          <div class="ratio__modal-btns">
            <button class="btn cancel" @click="cancel()">reject</button>
            <button class="btn confirm" @click="confirm()">confirm</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import { cloneDeep } from 'lodash';

export default {
  props: {
    slope: Object,
    isContr: Boolean,
  },
  data() {
    return {
      pickedMaterial: {},
      pickedBase: 'default',
      recommendedRatio: 3,
      isModalShow: false,
      // slopeForm: this.slopeFromState.slopeForm,
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      mainSlope: 1.7,
      roofBaseTypes: [
        {
          id: 0,
          value: 'proflist',
          label: 'Corrugated steel sheet',
        },
        {
          id: 1,
          value: 'concrete',
          label: 'Concrete',
        },
        {
          id: 2,
          value: 'OSB',
          label: 'OSB',
        },
      ],
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
      compliance: [
        {
          ratio: 2,
          larger: 1.6,
          lower: 0,
        },
        {
          ratio: 3,
          larger: 2.1,
          lower: 1.6,
        },
        {
          ratio: 4,
          larger: 2.6,
          lower: 2.1,
        },
        {
          ratio: 5,
          larger: 11,
          lower: 2.6,
        },
      ],
    };
  },
  components: {
    Multiselect,
  },
  methods: {
    changeSlopeCount() {
      this.$store.commit('updateSlopeCount', { id: this.slopeId, count: this.slope.slopeCount });
    },
    changeSlopeLayersCount() {
      this.$store.commit('updateSlopeLayersCount', { id: this.slopeId, count: this.slope.slopeLayersCount });
    },
    changeFixtureCalculation() {
      this.$store.commit('updateFixtureCalculation', { id: this.slopeId, need: this.slope.fixtureCalculation.need, slopeType: this.slope.slopeType });
    },
    changeFixtureCalculationBase() {
      this.$store.commit('updateFixtureCalculationBase', { id: this.slopeId, val: this.slopeFromState.fixtureCalculation.base });
    },
    changeFixtureCalculationMaterial() {
      this.$store.commit('updateFixtureCalculationMaterial', { id: this.slopeId, material: this.slopeFromState.fixtureCalculation.material });
      // console.log(this.allMaterials[this.qqq]);
    },
    changeRoofBaseType() {
      this.$store.commit('updateFixtureCalculationType', { id: this.slopeId, type: this.slope.fixtureCalculation.type });
    },
    changeFixtureCalculationThickness() {
      this.$store.commit('updateFixtureCalculationThickness',
        { id: this.slopeId, val: this.slope.fixtureCalculation.thickness });
    },
    changeFixtureCalculationParamsOfBase() {
      this.$store.commit('updateFixtureCalculationParamsOfBase',
        { id: this.slopeId, val: this.pickedBase });
    },
    changeRoofSlope() {
      // console.log(this.slope.slopeParams[0].roofSlope);
      this.$store.commit('updateRoofSlope', { id: this.slopeId, val: this.slope.slopeParams[0].roofSlope });
      this.compareSlopeWithRatio(this.slope.slopeParams[0].roofSlope);
    },
    styleInputRange() {
      if (this.isContr) {
        document.documentElement.classList.add('js');
        this.$refs.inputRange.addEventListener('input', () => {
          this.$refs.inputRange.style.setProperty('--val', +this.$refs.inputRange.value);
        }, false);
      }
    },
    compareSlopeWithRatio(currentValue) {
      this.recommendedRatio = this.compliance[this.compliance.findIndex(
        p => (p.lower <= currentValue) && (currentValue < p.larger),
      )].ratio;
      if (this.slopeFromState.slopeParams[0].ratio !== this.recommendedRatio) {
        this.isModalShow = true;
        this.$root.offBodyScroll();
      }
    },
    cancel() {
      this.isModalShow = false;
      this.$root.onBodyScroll();
    },
    confirm() {
      this.isModalShow = false;
      this.$root.onBodyScroll();
      this.$store.commit('updateSlopeRatioNew', { id: this.slopeId, ratio: this.recommendedRatio });
    },
  },
  mounted() {
    this.styleInputRange();
    // this.pickedMaterial = this.allMaterials[0];
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    sortedMaterials() {
      return cloneDeep(this.allMaterials).sort((a, b) => a.angle - b.angle);
    },
  },
};
</script>

<style lang="sass">
.slopePage
  .fixtureCalculation
    display: flex
    +media((flex-direction: (320: column, 768: row)))
    +media((padding-left: (320: rem(9), 768: rem(25))))
    +media((padding-top: (320: rem(28), 768: rem(40))))
    &__toggle
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      +media((padding-right: (320: rem(12), 768: rem(25))))
      .slopePage__subtitle
        margin: 0
    &--contr
      padding-left: rem(15)
      flex-direction: column
      .roofType
        &:last-of-type
          .roofType
            &__title
              margin-bottom: rem(13)
        &__box
          margin-bottom: rem(34)
          justify-content: flex-start
  .roofType
    display: flex
    flex-direction: column
    align-items: flex-start
    justify-content: space-between
    +media((margin-right: (320: 0, 768: rem(40))))
    &__title
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(18)
      color: $black
      margin-bottom: rem(20)
    &__box
      display: flex
      flex-direction: row
      justify-content: flex-start
      align-items: center
      box-sizing: border-box
      overflow: hidden
      +media((margin-bottom: (320: rem(32), 768: rem(3))))
      +media((width: (320: rem(272), 360: rem(312), 768: rem(282))))
      &-btn
        width: rem(94)
        display: block
        margin: 0
        background: transparent
        color: #333
        transition: .5s
        position: relative
        cursor: pointer
        +media((height: (320: rem(48), 768: rem(34))))
        input
          pointer-events: none
        &:first-of-type
          label
            border-top-left-radius: rem(4)
            border-bottom-left-radius: rem(4)
        &:last-of-type
          label
            border-top-right-radius: rem(4)
            border-bottom-right-radius: rem(4)
        &__label
          border: rem(1) solid #C9C9C9
          height: 100%
          width: 100%
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          transition: .5s
          cursor: pointer
          font-size: rem(12)
          transition: .5s
          font-weight: 500
          &:hover
            border-color: $red
          &.active
            background: $red
            color: #fff
            border-color: $red
        input
          position: absolute
          top: 0
          opacity: 0
  .slopeForm
    +media((margin-bottom: (320: rem(16), 768: rem(34))))
    &__box
      display: flex
      flex-direction: row
      align-items: center
      overflow-x: auto
      +media((padding-left: (320: 0, 992: rem(20))))
      +media((padding-right: (320: 0, 992: rem(20))))
      position: relative
      +media((border-left: (320: rem(24) solid #fff, 992: 0)))
      +media((border-right: (320: rem(24) solid #fff, 992: 0)))
      &-item
        +media((margin-left: (320: 0, 992: rem(20))))
        +media((margin-right: (320: rem(30), 992: rem(20))))
        input
        &__btn
          filter: grayscale(1)
          opacity: .2
          transition: .5s
          cursor: pointer
          &__input
            opacity: 0
            position: absolute
          img
            width: rem(68)
          &:hover
            opacity: .5
            filter: grayscale(.5)
          &--active
            filter: grayscale(0)
            opacity: 1
            &:hover
              filter: grayscale(0)
              opacity: 1
  .input
    &__params
      &-box
        display: flex
        // justify-content: center
        +media((flex-direction: (320: row, 768: column)))
        +media((padding: (320: 0 rem(14), 992: 0)))
        justify-content: center
        flex-wrap: wrap
    &__box
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      background: #FFFFFF
      box-sizing: border-box
      height: rem(50)
      position: relative
      margin-bottom: rem(10)
      +media((width: (320: auto, 768: 100%, 992: rem(235))))
      +media((margin-left: (320: 0, 992: rem(30))))
      &:after
        content: ""
        position: absolute
        background: $violet
        +media((border-radius: (320: 0 0 rem(4) rem(4), 768: rem(4) 0 0 rem(4))))
        +media((height: (320: rem(5), 768: 100%)))
        +media((width: (320: 100%, 768: rem(5))))
        +media((left: (320: 0, 768: rem(-4))))
        +media((top: (320: initial, 768: 0)))
        +media((bottom: (320: rem(-4), 768: initial)))
      span
        font-style: normal
        font-weight: 500
        color: #5C5C5C
        pointer-events: none
        position: absolute
        +media((font-size: (320: rem(12), 768: rem(14))))
        +media((line-height: (320: rem(16), 768: rem(18))))
        +media((width: (320: rem(65), 360: rem(78), 480: 100%, 768: rem(111))))
        +media((left: (320: 0, 768: rem(16))))
        +media((text-align: (320: center, 768: left)))
        +media((bottom: (320: rem(-35), 768: initial)))
        +media((height: (320: rem(32), 768: auto)))
        +media((padding: (320: rem(5), 768: 0)))
        i
          font-style: normal
          +media((display: (320: none, 480: inline-block)))
        em
          +media((display: (320: inline-block, 480: none)))
      &-input
        border: none
        box-shadow: none
        outline: none
        padding: 0
        height: 100%
        font-style: normal
        font-weight: 600
        font-size: rem(18)
        line-height: rem(22)
        font-family: $main-font
        border: rem(1) solid #C9C9C9
        color: rgba(28, 28, 27, 0.9)
        transition: .5s
        +media((padding-left: (320: 0, 768: rem(140))))
        +media((padding-right: (320: 0, 768: rem(15))))
        +media((border-radius: (320: 0, 768: 0 rem(4) rem(4) 0)))
        +media((width: (320: rem(65), 360: rem(78), 480: calc((100vw - 58px) / 4), 768: 100%)))
        +media((text-align: (320: center, 768: right)))
      &-width
        &:after
          background: $violet
        .input__box-input
          &:hover, &:focus
            border-color: $violet
      &-height
        &:after
          background: $blue
        .input__box-input
          &:hover, &:focus
            border-color: $blue
      &-bias1, &-biasHeight
        &:after
          background: $yellow
        .input__box-input
          &:hover, &:focus
            border-color: $yellow
      &-bias2, &-biasWidth
        &:after
          background: $orange
        .input__box-input
          &:hover, &:focus
            border-color: $orange
  .similar
    &__wrapper
      padding: 0
    &__box
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      border-bottom: rem(1) solid #ECECEC
      +media((padding: (320: rem(15) rem(24) rem(15) rem(15),
      768: rem(31) rem(40) rem(31) rem(15))))
      &:first-of-type
        padding-top: 0
      &:last-of-type
        padding-bottom: 0
        border: none
      &-title
        text-align: left
        margin: 0
        line-height: rem(22)
        +media((padding-right: (320: rem(10), 768: 0)))
      &-inputs
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        &-input
          background: #FFFFFF
          border: rem(1) solid #C9C9C9
          box-sizing: border-box
          border-radius: rem(4)
          width: rem(68)
          height: rem(40)
          text-align: center
          outline: none
          margin: 0 rem(9)
          font-family: $main-font
          font-style: normal
          font-weight: 600
          font-size: rem(18)
          line-height: rem(22)
          color: rgba(28, 28, 27, 0.9)
          transition: .5s
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          &:hover, &:focus
            border-color: $green
          &.info
            pointer-events: none
            +media((margin: (320: 0 0 0 rem(10), 768: 0 rem(31))))
        &-range
        &-button
          border: none
          box-shadow: none
          background: none
          outline: none
          cursor: pointer
          width: rem(22)
          height: rem(22)
          background: $red
          border-radius: rem(2)
          color: #fff
          font-weight: 700
          font-size: rem(16)
          padding: 0
          line-height: 1
          font-family: $main-font
          display: flex
          flex-direction: column
          justify-content: center
          align-items: center
  .materials__select
    display: flex
    flex-direction: column
    align-items: flex-start
    padding-top: rem(40)
    text-align: left
    +media((padding-left: (320: rem(9), 768: rem(25))))
    .styled-radio
      &:last-of-type
        margin-bottom: rem(26)
    .multiselect__content-wrapper
      max-height: rem(204)!important
    .multiselect__option--selected
      background: #eeeeee
      .option-info__title
        font-weight: 700!important
    .multiselect__option--highlight
      background: $red
      .option__info-angle
        svg
          path
            fill: #fff
    .multiselect__option--selected.multiselect__option--highlight
      background: $red-hover
    .multiselect
      width: rem(320)
      height: rem(68)
      // padding-top: rem(10)
      +media((margin-left: (320: 0, 768: rem(40))))
      +media((max-width: (320: 100%, 768: unset)))
      color: $black
      cursor: pointer
      .multiselect
        &__tags, &__single
          padding: 0
          margin: 0
          background: transparent
        &__tags
          padding: rem(10) rem(12)
          border: rem(1) solid #ECECEC
        &__select
          height: 100%
          cursor: pointer
          &:before
            transition: .5s
            cursor: pointer
            opacity: 1
            height: rem(6)
            width: rem(12)
            margin: 0
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
            position: absolute
            right: rem(18)
            border: none
            background-repeat: no-repeat
            background-position: center
            background-image: url(../assets/img/select-tick-red.svg)
      .option
        &__box
          display: flex
          flex-direction: row
          align-items: center
        &__img
          display: flex
          flex-direction: row
          align-items: center
          padding-right: rem(16)
          img
            height: rem(47)
        &__info
          font-size: rem(14)
          line-height: rem(17)
          &-title
            font-style: normal
            font-weight: 500
            padding-bottom: rem(6)
          &-angle
            font-family: Montserrat
            font-style: normal
            font-weight: bold
            img
              padding-right: rem(6)
.ratio
  &__modal
    background: #FFFFFF
    box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.3)
    border-radius: rem(4)
    color: $black
    width: rem(300)
    // height: rem(160)
    padding: rem(35) rem(15)
    position: relative
    z-index: 9999
    display: block
    &-overlay
      z-index: 4
      position: fixed
      top: 0
      left: 0
      height: 100vh
      width: 100vw
      background: rgba(0, 0, 0, 0.3)
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center
    .text
      font-style: normal
      font-weight: bold
      font-size: rem(16)
      line-height: rem(20)
      padding-bottom: rem(24)
      text-align: left
      span
        color: $red
    .subtext
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(18)
      text-align: left
      padding-bottom: rem(20)
    .info
      font-size: rem(12)
      line-height: rem(14)
      text-align: left
      font-style: normal
      font-weight: 500
      color: #a6a6a6
      padding-bottom: rem(20)
    &-btns
      .btn
        font-family: $main-font
        height: rem(30)
        box-shadow: none
        border: none
        background: none
        border-radius: rem(4)
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(16)
        cursor: pointer
        margin: 0 rem(2)
        outline: none
        transition: .5s
        &.cancel
          background: #ECECEC
          min-width: rem(80)
          &:hover
            background: #cdcdcd
        &.confirm
          background: $green
          min-width: rem(93)
          color: #fff
          &:hover
            background: $green-hover
</style>
